module.exports = __webpack_public_path__ + "img/xwzx.1ec9d5f5.png";